/**
 * Author: Paul Grejaldo
 * Date: 2018/10/16
 * Time: 5:13 PM
 */
import React, { Component, Fragment } from 'react';
//import ReactDOM from 'react-dom';
//import PropTypes from 'prop-types';

class Row extends Component {
	constructor( props ) {
		super( props );
	}

	componentDidCatch( error, info ) {
		console.log( error );
		console.log( info );
	}

	render() {
		return (
			<div className="row">
				{this.props.children}
			</div>
		);
	}
}

Row.propTypes = {};

Row.defaultProps = {};

export default Row;
